import { autobind } from 'frontools/decorators/Autobind';
declare var Swiper: any;
/**
    * Sliders description
    * (c) lg2fabrique 2017
*/

export default class Slider {
    private swipersArr          : Array<any>         = [];
    private sliderEl            : HTMLElement;
    private slider;

    private _obj                : any               = {

                                                            speed: 300,
                                                            slidesPerView: 5,
                                                            slidesPerGroup: 5,
                                                            spaceBetween: 30,
                                                            setWrapperSize: true,

                                                            pagination: {
                                                                el: '.swiper-container .pagination',
                                                                clickable: true,
                                                                type: 'bullets'
                                                            },
                                                            breakpoints: {
                                                                768: {
                                                                    centeredSlides: true,
                                                                    slidesPerView: "auto",
                                                                    slidesPerGroup: 1,
                                                                    spaceBetween: 30,
                                                                }
                                                            },

                                                        };
    /**
    * constructor
    */
    constructor(el: HTMLElement = document.querySelector('[data-js="swiper"]') as HTMLElement, private _config: Object = {}) {
        // Merge configs
        this._config = {...this._obj, ...this._config};

        // Remove some parameters on specific sliders
        if (el === document.querySelector('.ingredients_slider[data-js="swiper"]')) this._config['slideToClickedSlide'] = false;

        // Get all sliders
        this.sliderEl = el;

        if (this.sliderEl) {
            this.init(this.sliderEl, {...this._config});
        }
    }

    /*
    * Init sliders
    */
    private init(el: HTMLElement, config) {
        this.slider = new Swiper(el, config);
        // console.log(this.slider);
    }

    @autobind
    public destroy() {
        if (this.slider.destroy(true, true)) {
             this.slider.destroy(true, true);
        }
    }

    /*
    * Get slider
    */
    @autobind
    public get swiper() {
       return this.slider;
    }
}
